export const updatePreloadCount = (state, { action }) => {
  state.preloadStatus[action.name] = { ...(state.preloadStatus[action.name] || {}), ...action };
};

export const setPreloadingFlag = (state, value) => {
  state.preloadStatus = {
    Languages: {
      name: 'Languages'
    },
    'User Details': {
      name: 'User Details'
    },
    'Users Delegated By': {
      name: 'Users Delegated By'
    },
    'System Variables': {
      name: 'System Variables'
    }
  };
  state.apisPreloading = value;
};
